import { render, staticRenderFns } from "./project-progress.vue?vue&type=template&id=025efd7b&scoped=true"
import script from "./project-progress.vue?vue&type=script&lang=js"
export * from "./project-progress.vue?vue&type=script&lang=js"
import style0 from "./project-progress.vue?vue&type=style&index=0&id=025efd7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025efd7b",
  null
  
)

export default component.exports